import { devPageIndices, tableSortingEntries, devsTableIndices, tableDevsSortingEntries, devRankStyles, userClasses, passwordPattern, memberProfileStyles } from "../entries";
import React, { useState, useEffect, useContext } from "react";
import { IoMdArrowDropdown, IoMdArrowDropup } from "react-icons/io";
import { capitalizeFirstLetter, eqSet, formatTimestamp, IsoFormatToCustom, setImageUrl, validatePassword } from "../utils";
import { rowsPerPage } from "../entries";
import { useNavigate } from "react-router-dom";
import { AccountContext } from "../contexts/AccountContexts";
import { CategoryBubble, ExpandableBubbleSidebar, PriorityBubble, StatusBubble, ticketCategoryConfigs } from "./TicketComponents";
import { IoChatbubbleOutline, IoChatbubbleSharp, IoKey, IoTicketOutline } from "react-icons/io5";
import { TbUser, TbUserCog, TbUserOff } from "react-icons/tb";
import { CiEdit } from "react-icons/ci";
import { MdAlternateEmail, MdClose, MdDone, MdOutlineAlternateEmail, MdOutlineDeleteOutline, MdOutlineRestartAlt, MdQuestionMark } from "react-icons/md";
import { ContentContext } from "../contexts/ContentContext";
import { requestChangeDevResponsibilities, requestChangePassword, requestCheckEmailExists, requestCreateNewUser, requestDeleteDev, requestDisableUser, requestDisableUserUntil, requestDisperseUserTickets, requestEnableUser } from "../requests/users_requests";
import { requestAddTicketsToChat, requestAddTicketToChat, requestChat, requestChats, requestFetchTaggedChats, requestIsPinnedTicket, requestRemoveTicketFromChat } from "../requests/chat_requests";
import { PasswordRulesModule } from "./AuthComponents";
import { useTranslation } from "react-i18next";
import { PermissionContext } from "../contexts/PermissionContexts";
import { BiCategory } from "react-icons/bi";
import { darkAndLightThemeDefault } from "./ThemeComponents";
import { CgPlayListAdd } from "react-icons/cg";
import { componentLoadingActive, ComponentLoadingScreen, loadingActive } from "./Background";
import { Pagination } from "./PaginationComponents";
import { requestAllPermissionsList, requestChangeUserPermissions, requestRankPermissionList, requestUserPermissionList } from "../requests/general_requests";

const ENABLE_PREVIEW = true


const DataTable = ({ data, setData, members, activeChatIds, sortConfig, setSortConfig, entriesPerPage, setEntriesPerPage, 
    currentPage, setCurrentPage, totalPages, setTotalPages, totalCount, fetchTaggedChats, filterTaggedChats, setFilterTaggedChats}) => {
    const { t } = useTranslation('common')
    const { user, devs } = useContext(AccountContext)
    const { servers, openErrorModal } = useContext(ContentContext)

    const [oldData, setOldData] = useState(data)


    useEffect(() => {
        setOldData(data)
    }, [data])

    const handleSort = (key) => {
        let direction = "asc";
        if (sortConfig.key === key && sortConfig.direction === "asc") {
            direction = "desc";
        }
        if (sortConfig.key === key && sortConfig.direction === "desc") {
            key = null
        }
        if (sortConfig.key !== key || sortConfig.direction !== direction) {
            setCurrentPage(1)
        }

        setSortConfig({ key, direction });
    };

    const getArrow = (key) => {
        if (sortConfig.key === key) {
            if (sortConfig.direction === "asc") {
                return <IoMdArrowDropup size={16} className="inline ml-1" />;
            } else {
                return <IoMdArrowDropdown size={16} className="inline ml-1" />;
            }
        }
        return null;
    };

    const handlePerPage = (event) => {
        localStorage.setItem(user.id + "_perPage", event.target.value)
        if (event.target.value !== entriesPerPage) {
            setCurrentPage(1)
        }
        setEntriesPerPage(event.target.value)
    }

    const handleAddTicketsToChats = () => {
        loadingActive(true)
        let ticketIds = []
        for (let i = 0; i < data.length; i++) {
            ticketIds.push(data[i].id)
        }
        requestAddTicketsToChat({ ticketIds: ticketIds })
            .then(() => {

            })
            .catch((error) => {
                console.error(error.status, error.message)
            })
            .finally(() => {
                loadingActive(false)
            })
    }

    const handleAddTaggedTicketsToChats = () => {
        loadingActive(true)
        // let ticketIds = []
        // for (let i = 0; i < fetchTaggedChats.length; i++) {
        //     ticketIds.push(fetchTaggedChats[i].room_id)
        // }
        setFilterTaggedChats(!filterTaggedChats)
        
        requestFetchTaggedChats({ tagged: !filterTaggedChats, entriesPerPage: entriesPerPage, currentPage: currentPage }).then((data) => {
            setData(data.tickets)
            setCurrentPage(currentPage)
            setTotalPages(data.total_pages) 
            setCurrentPage(1)
        }).finally(() => {
            loadingActive(false)
        })
        // requestAddTicketsToChat({ ticketIds: ticketIds })
        //     .then(() => {

        //     })
        //     .catch((error) => {
        //         console.error(error.status, error.message)
        //         openErrorModal(error)
        //     })
        //     .finally(() => {
        //         loadingActive(false)
        //     })
    }


    return (
        <>
            {/* <div className="flex w-full mt-4 px-4 gap-2 items-center justify-between"> */}
            <div className="grid grid-cols-3 w-full mt-4 px-4 items-center">
                <div className="flex gap-4 items-center">
                    <div className="flex gap-2 items-center">

                        <select required className=" select select-sm h-10 select-bordered w-[70px] bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-300 border-gray-300 dark:border-gray-600" value={entriesPerPage} onChange={handlePerPage}>
                            {/* <option value={1}>All</option> */}
                            {rowsPerPage.map((i, index) => (<option key={index} value={i} >{i}</option>))}
                        </select>
                        <p>{t('entries per page')}</p>
                    </div>
                    <button className={`btn btn-sm ${darkAndLightThemeDefault} p-0 w-8 h-8 pt-1 ltr:pl-1 rtl:pr-1`} title={t("Add all to Chats")} onClick={handleAddTicketsToChats}> <CgPlayListAdd size={20} /></button>
                    <button className={`btn btn-sm p-0 w-8 h-8 ${filterTaggedChats ? "hover:bg-blue-500 hover:border-0 bg-blue-600 text-white border border-gray-500 " : darkAndLightThemeDefault}`} title={t("Add all to Assigned")} onClick={handleAddTaggedTicketsToChats}> <MdAlternateEmail size={20} /></button>
                </div>
                <Pagination currentPage={currentPage} setCurrentPage={setCurrentPage} totalPages={totalPages} top={true} />
                <div className="justify-self-end">
                    <p>{totalCount ? totalCount : data.length} {t('entries')}</p>
                </div>
            </div>

            <div className="overflow-x-auto w-full">

                <table className="table  w-full" >
                    <thead className="bg-gray-100 dark:bg-gray-800 text-gray-800 dark:text-gray-300">
                        <tr className="border-gray-300 dark:border-gray-600">

                            {Object.keys(devPageIndices).map((el, index) => (
                                <th className="max-w-xs truncate cursor-pointer select-none" key={index}
                                    onClick={() => { tableSortingEntries[index] && handleSort(tableSortingEntries[index]) }}
                                >
                                    <div className="flex items-center">
                                        {t(el)} {tableSortingEntries[index] && getArrow(tableSortingEntries[index])}
                                    </div>
                                </th>
                            ))}
                        </tr>
                    </thead>

                    <tbody>

                        {data
                            .map((ticketItems, index) => (
                                <tr key={index} className="h-20 border-gray-300 dark:border-gray-600">
                                    <td className="max-w-xs relative"><TicketButton ticketItems={ticketItems} /></td>
                                    <td className="max-w-xs truncate"><AddtoChatCheckbox ticketId={ticketItems.id} isActive={activeChatIds.includes(String(ticketItems.id)) || activeChatIds.includes(ticketItems.id)} /></td>
                                    <td className={`max-w-xs truncate`}><MemberProfileComponent ticket={ticketItems} member={members[ticketItems.user_id]} /></td>
                                    <td className="max-w-xs truncate"><MemberCharacterComponent ticket={ticketItems} /></td>
                                    <td className={`max-w-xs truncate ${ticketItems.banned && "text-red-600"}`}>{ticketItems.email}</td>
                                    <td className="max-w-xs truncate">{servers[ticketItems.server]?.title}</td>
                                    <td className="max-w-xs truncate"><CategoryBubble ticketCategory={ticketItems.category} /> </td>
                                    <td className="max-w-xs truncate"><StatusBubble ticketStatus={ticketItems.status} /></td>
                                    <td className="max-w-xs truncate"><PriorityBubble ticketPriority={ticketItems.priority ? ticketItems.priority : "Normal"} /></td>
                                    <td className="max-w-xs truncate">{formatTimestamp(ticketItems.lastUpdated * 1000)}</td>
                                    <td className="max-w-xs truncate">{formatTimestamp(ticketItems.createdAt * 1000)}</td>
                                    <td className="max-w-xs truncate">
                                        {ticketItems.assignedTo ? devs[ticketItems.assignedTo].name : "-"}
                                    </td>
                                </tr>
                            ))}

                    </tbody>
                </table>
                <div className={`flex w-full justify-center bg-white dark:bg-gray-700 p-5 rounded-b-lg ${data.length !== 0 && "hidden"}`}>
                    <p>{t('No entries found')}</p>
                </div>
            </div>
            {/* <PaginationComponent data={data} sortedData={sortedData} entriesPerPage={entriesPerPage} setIndexOfFirstEntry={setIndexOfFirstEntry}
                setIndexOfLastEntry={setIndexOfLastEntry} dataName={"_ticketsPage"} /> */}
            <Pagination currentPage={currentPage} setCurrentPage={setCurrentPage} totalPages={totalPages} />
        </>
    )
}


export const MemberProfileComponent = ({ ticket, member }) => {
    const [spamLevel, setSpamLevel] = useState(0)

    const navigator = useNavigate()

    useEffect(() => {
        if (member) {
            setSpamLevel(Math.floor(member?.n_tickets / 20) ?? 0)
        }
    }, [member])

    const handleNavigateToProfile = () => {
        navigator(`/admin/members/member-profile/${member.id}`)
    }

    return (
        member ?
            <button title={ticket.name} className={`btn btn-sm border max-w-32 truncate border-gray-300 dark:border-gray-600 ${ticket?.banned ? "bg-red-600 text-white" : "bg-gray-100 dark:bg-gray-800 text-gray-800 dark:text-white"} ${memberProfileStyles[spamLevel]}`}
                onClick={handleNavigateToProfile}
            >
                <span className="truncate">{ticket.name}</span>
            </button>
            :
            <span className={`${ticket.banned && "text-red-600"}`}>{ticket.name}</span>
    )
}


export const MemberCharacterComponent = ({ ticket }) => {

    return (
        <div className="flex justify-start font-semibold truncate rounded-lg p-[2px] label-sm">
            <span className={`${ticket.banned && "text-red-600"}`}>{ticket.characterName}</span>
        </div>
    )
}


export const PaginationComponent = ({ data, sortedData, entriesPerPage, setIndexOfFirstEntry, setIndexOfLastEntry, dataName = null }) => {
    const { t } = useTranslation('common')
    const { user } = useContext(AccountContext)
    const [currentPage, setCurrentPage] = useState(1);

    useEffect(() => {
        // Calculate the index range for the current page
        const indexOfLastEntry = currentPage * entriesPerPage;
        const indexOfFirstEntry = indexOfLastEntry - entriesPerPage;
        localStorage.setItem(user.id + "_ticketsPage", currentPage)
        setIndexOfFirstEntry(indexOfFirstEntry)
        setIndexOfLastEntry(indexOfLastEntry)

    }, [currentPage, sortedData])

    useEffect(() => {
        // Calculate the index range for the current page
        if (entriesPerPage !== parseInt(localStorage.getItem(user.id + "_perPage"))) {

            const indexOfLastEntry = entriesPerPage;
            const indexOfFirstEntry = indexOfLastEntry - entriesPerPage;
            setCurrentPage(1)
            localStorage.setItem(user.id + "_ticketsPage", 1)
            setIndexOfFirstEntry(indexOfFirstEntry)
            setIndexOfLastEntry(indexOfLastEntry)
        }

    }, [entriesPerPage])


    useEffect(() => {
        if (dataName) {
            const currPage = localStorage.getItem(user.id + dataName)
            if (currPage) {
                setCurrentPage(parseInt(currPage))
            }
            else {
                setCurrentPage(1)
            }
        }
        else {
            setCurrentPage(1)
        }
    }, [data])

    // Calculate total pages
    const totalPages = Math.ceil(sortedData.length / entriesPerPage);

    // Handle page change
    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
        if (dataName) {
            localStorage.setItem(user.id + dataName, pageNumber)
        }
    };

    const getPaginationGroup = () => {
        const pageNumbers = [];
        const maxPagesToShow = 9;
        const nSideMax = (maxPagesToShow - 5) / 2

        if (totalPages <= maxPagesToShow) {
            // Show all pages if total pages are less than or equal to maxPagesToShow
            for (let i = 1; i <= totalPages; i++) {
                pageNumbers.push(i);
            }
        } else {
            // Show ellipses if total pages exceed maxPagesToShow
            const leftLimit = Math.max(2, currentPage - nSideMax);
            // const rightLimit = totalPages - nSideMax - currentPage;
            const rightLimit = Math.min(totalPages - 2, 2 * nSideMax + leftLimit);

            // Always show the first page
            pageNumbers.push(1);

            // Show ellipses if there are hidden pages to the left
            if (leftLimit > 2) {
                pageNumbers.push("...");
            }

            let addToLeft = rightLimit < totalPages - 2 ? leftLimit : totalPages - 2 * nSideMax - 1
            // let addToRight = rightLimit >= 2 ? currentPage + nSideMax  : totalPages + 1
            let addToRight = addToLeft + 2 * nSideMax + 1 > totalPages - 1 ? totalPages - 1 : addToLeft + 2 * nSideMax + 1



            // Show page numbers between leftLimit and rightLimit
            for (let i = addToLeft; i < rightLimit + 1; i++) {
                pageNumbers.push(i);
            }

            // Show ellipses if there are hidden pages to the right
            // if (rightLimit <= totalPages - 1) {
            //   pageNumbers.push("...");
            // }
            if (rightLimit < totalPages - 2) {
                pageNumbers.push("...");
            }
            else {
                pageNumbers.push(totalPages - 1)
            }
            // Always show the last page
            pageNumbers.push(totalPages);

        }

        return pageNumbers;
    };

    return (
        <div className={`${sortedData.length == 0 && "hidden"} flex justify-center my-4 mt-auto`}>
            <nav>
                <ul className="pagination flex list-none">
                    {/* Previous Button */}
                    <li>
                        <button
                            className={`btn btn-sm ${currentPage === 1 ? "btn-disabled" : "bg-white dark:bg-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 text-gray-800 dark:text-gray-300 border-gray-300 dark:border-gray-600 hover:border-gray-300 dark:hover:border-gray-500"}`}
                            onClick={() => handlePageChange(currentPage - 1)}
                            disabled={currentPage === 1}
                        >
                            {t('Previous')}
                        </button>
                    </li>

                    {/* Page Numbers with ellipses */}
                    {getPaginationGroup().map((page, index) => (
                        <li key={index} className="mx-[2px]">
                            {page === "..." ? (
                                <span className="btn btn-sm btn-disabled">...</span>
                            ) : (
                                <button
                                    className={`btn btn-sm ${currentPage === page ? "btn-active bg-primary text-white hover:bg-primary/80 border-gray-300 dark:border-gray-600" : "bg-white dark:bg-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 text-gray-800 dark:text-gray-300 border-gray-300 dark:border-gray-600 hover:border-gray-300 dark:hover:border-gray-500"}`}
                                    onClick={() => handlePageChange(page)}
                                >
                                    {page}
                                </button>
                            )}
                        </li>
                    ))}

                    {/* Next Button */}
                    <li>
                        <button
                            className={`btn btn-sm ${currentPage === totalPages ? "btn-disabled" : "bg-white dark:bg-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 text-gray-800 dark:text-gray-300 border-gray-300 dark:border-gray-600 hover:border-gray-300 dark:hover:border-gray-500"}`}
                            onClick={() => handlePageChange(currentPage + 1)}
                            disabled={currentPage === totalPages}
                        >
                            {t('Next')}
                        </button>
                    </li>
                </ul>
            </nav>
        </div>
    )
}

export const RemovePinnedTicketModal = ({ open, setOpen, ticketId, setLoading, setIsInChats }) => {
    const { t } = useTranslation('edit')

    const handleClose = () => {
        setOpen(false)
        setLoading && setLoading(false)
    }

    const handleRemove = () => {
        requestRemoveTicketFromChat({ ticketId: ticketId })
            .then((data) => {
                setLoading && setLoading(false)
                setOpen(false)
                setIsInChats && setIsInChats(false)
            }).catch((error) => {
                console.error(error.status, error.message)
                setLoading && setLoading(false)
                setOpen(false)
            })
        }

    return (
        <div className={`${open ? "block" : "hidden"} w-full bg-black h-screen bg-opacity-50 fixed inset-0 z-50 flex items-center justify-center`} id={`remove-pinned-ticket-modal`}>
            <div className="modal-box">
                <h3 className="font-bold text-lg">{t('Remove pinned ticket')}</h3>
                <p className="py-4">{t('Are you sure you want to remove this pinned ticket?')}</p>
                <small className="text-sm">{t('This ticket will be remove from pinned tickets.')}</small>
                <div className="modal-action">
                    <button className="btn" onClick={() => handleClose()}>{t('Cancel')}</button>
                    <button className="btn btn-error" onClick={handleRemove}>{t('Remove')}</button>
                </div>
            </div>
        </div>
    )
}


export const AddtoChatCheckbox = ({ ticketId, isActive }) => {
    const { t } = useTranslation('edit')

    const [isInChats, setIsInChats] = useState(false);
    const [loading, setLoading] = useState(true);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        setIsInChats(!!isActive)
        setLoading(false)
    }, [isActive])

    const handleClick = async(e) => {
        e.preventDefault()
        if (loading) {
            return null;
        }
        setLoading(true)

        if (!isInChats) {
            requestAddTicketToChat({ ticketId: ticketId })
                .then((data) => {
                    setLoading(false)
                    setIsInChats(true)
                }).catch((error) => {
                    console.error(error.status, error.message)
                    setLoading(false)
                })
        }
        else {
            const request = await requestIsPinnedTicket({ ticketId: ticketId });
            const isPinned = request.pinned;

            if(isPinned) {
                setOpen(true)
            } else {
            requestRemoveTicketFromChat({ ticketId: ticketId })
                .then((data) => {
                    setLoading(false)
                    setIsInChats(false)
                }).catch((error) => {
                    console.error(error.status, error.message)
                    setLoading(false)
                })
            }
        }

    }

    return (
        <div className="flex w-full">
            <div className={`flex w-full text-primary dark:text-blue-600 justify-center items-center select-none pr-2 ${!loading && "hover:text-sky-600 dark:hover:text-sky-500 cursor-pointer active:scale-95 active:-translate-x-[1px] hover:scale-105 hover:-translate-x-[1px]"}`}
                title={t(isInChats ? "Remove from Chats" : "Add to Chats")}
                onClick={handleClick}
            >

                {
                    loading ?
                        <span className="loading loading-ring loading-md"></span>
                        :
                        isInChats ?
                            <IoChatbubbleSharp size={24} />
                            :
                            <IoChatbubbleOutline size={24} />

                }
            </div>
            <RemovePinnedTicketModal open={open} setOpen={setOpen} ticketId={ticketId} setLoading={setLoading} setIsInChats={setIsInChats} />
        </div>
    )
}


export const TicketButton = ({ ticketItems }) => {
    const navigator = useNavigate();

    const { t } = useTranslation('common')

    const [showPreview, setShowPreview] = useState(false)

    const to = `/admin/${ticketItems.fetch_code}/edit`

    const handleClick = (e) => {
        e.preventDefault()
        if (e.button === 0 && !e.ctrlKey && !e.metaKey) {
            e.preventDefault();
            navigator(to)
        }
    }

    return (
        <>
            <a href={to} className=" group label border rounded-lg p-2 py-3 bg-white dark:bg-gray-700 border-primary dark:border-blue-600 hover:bg-primary hover:text-white relative"
                onClick={handleClick}
                
                onMouseOver={() => { ENABLE_PREVIEW && !showPreview && setShowPreview(true) }}
                onMouseLeave={() => { ENABLE_PREVIEW && showPreview && setShowPreview(false) }}
                target="_self"
                rel="noopener noreferrer"
            >
                {/* <span className="font-normal justift-start text-start text-ellipsis group-hover:text-white max-w-40 overflow-clip break-all bg-clip-text text-transparent bg-gradient-to-r from-gray-900 via-gray-800 to-gray-100 transition-all duration-300"> */}
                <span className="font-normal text-center  max-w-40 transition-all duration-200 px-2">
                    {ticketItems.createdAt}
                </span>
            </a>
            {
                showPreview &&

                <div className="absolute left-[90%] -top-5 z-[10000] flex flex-col border bg-gray-300 border-gray-400 dark:bg-gray-800 max-w-96 p-1 rounded-md">
                    <table className="table-fixed border-separate border-spacing-1">
                        <tbody>

                            <tr className="border-none p-0 m-0 items-start justify-start text-start">
                                <td className="text-nowrap p-0 min-w-20 font-semibold">
                                    <span>{t('Character Name')}</span>
                                </td>
                                <td className="p-0 overflow-hidden max-w-60">
                                    <span className="truncate overflow-hidden">{ticketItems.characterName}</span>
                                </td>
                            </tr>
                            <tr className="border-none p-0 m-0 items-start justify-start text-start">
                                <td className="text-nowrap p-0 min-w-20 font-semibold">
                                    <span>{t('Subject')}</span>
                                </td>
                                <td className="p-0 overflow-hidden max-w-60">
                                    <span className="truncate overflow-hidden">{ticketItems.subject}</span>
                                </td>
                            </tr>
                            <tr className="border-none p-0 m-0 items-start justify-start text-start">
                                <td className="text-nowrap p-0 min-w-20 font-semibold">
                                    <span>{t('Description')}</span>
                                </td>
                                <td className="p-0 overflow-hidden max-w-60">
                                    <span className="truncate overflow-hidden">{ticketItems.description}</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            }
        </>
    )
}


export const DevTable = ({ data, selectedDev, setSelectedDev, activeTicketNumbers }) => {
    const { t } = useTranslation('common')
    const { devs } = useContext(AccountContext)

    const [sortConfig, setSortConfig] = useState({ key: "updated", direction: "asc" });
    const [entriesPerPage, setEntriesPerPage] = useState(25);
    const [currentEntries, setCurrentEntries] = useState([])
    const [indexOfFirstEntry, setIndexOfFirstEntry] = useState(0)
    const [indexOfLastEntry, setIndexOfLastEntry] = useState(0)



    const sortedData = React.useMemo(() => {
        let sortableData = [...data];


        if (sortConfig.key !== null) {
            sortableData.sort((a, b) => {
                const aValue = a[sortConfig.key];
                const bValue = b[sortConfig.key];

                // Handle undefined values
                if (aValue === undefined || aValue === "") return sortConfig.direction === "asc" ? 1 : -1;
                if (bValue === undefined || bValue === "") return sortConfig.direction === "asc" ? -1 : 1;

                // Handle different types
                const isNumber = (val) => typeof val === 'number';
                const isDate = (val) => !isNaN(Date.parse(val));

                // Case-insensitive string comparison
                if (typeof aValue === 'string' && typeof bValue === 'string') {
                    const aString = aValue.toLowerCase();
                    const bString = bValue.toLowerCase();
                    if (aString < bString) return sortConfig.direction === "asc" ? -1 : 1;
                    if (aString > bString) return sortConfig.direction === "asc" ? 1 : -1;
                }

                // Number comparison
                if (isNumber(aValue) && isNumber(bValue)) {
                    return sortConfig.direction === "asc" ? aValue - bValue : bValue - aValue;
                }

                // Date comparison
                if (isDate(aValue) && isDate(bValue)) {
                    const aDate = new Date(aValue).getTime();
                    const bDate = new Date(bValue).getTime();
                    return sortConfig.direction === "asc" ? aDate - bDate : bDate - aDate;
                }

                return 0;
            });
        }
        return sortableData;
    }, [data, sortConfig]);


    useEffect(() => {
        let _currentEntries = sortedData.slice(indexOfFirstEntry, indexOfLastEntry); // Entries for the current page
        setCurrentEntries(_currentEntries)

    }, [sortedData, indexOfFirstEntry, indexOfLastEntry])

    const handleSort = (key) => {
        let direction = "asc";
        if (sortConfig.key === key && sortConfig.direction === "asc") {
            direction = "desc";
        }
        setSortConfig({ key, direction });
    };

    const getArrow = (key) => {
        if (sortConfig.key === key) {
            if (sortConfig.direction === "asc") {
                return <IoMdArrowDropup size={16} className="inline ml-1" />;
            } else {
                return <IoMdArrowDropdown size={16} className="inline ml-1" />;
            }
        }
        return null;
    };

    const handlePerPage = (event) => {
        // event.preventDefault();
        setEntriesPerPage(event.target.value)
        // setCurrentPage(1);
    }


    return (
        <>
            <div className="flex w-full my-4 px-4 gap-2 items-center justify-between">
                <div className="flex gap-2 items-center">

                    <select required className=" select select-sm h-10 select-bordered w-[70px] bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-300 border-gray-300 dark:border-gray-600" value={entriesPerPage} onChange={handlePerPage}>
                        {/* <option value={1}>All</option> */}
                        {rowsPerPage.map((i, index) => (<option key={index} value={i} >{i}</option>))}
                    </select>
                    <p>{t('entries per page')}</p>
                </div>
                <div>
                    <p>{data.length} {t('entries')}</p>
                </div>
            </div>
            <div className="overflow-x-auto w-full pb-5">

                <table className="table w-full border-none" >
                    <thead className="bg-gray-100 dark:bg-gray-800 text-gray-800 dark:text-gray-300">
                        <tr className="border-gray-300 dark:border-gray-600">

                            {Object.keys(devsTableIndices).map((el, index) => (
                                <th className="max-w-xs truncate cursor-pointer select-none" key={index}
                                    onClick={() => { tableDevsSortingEntries[index] && handleSort(tableDevsSortingEntries[index]) }}
                                >
                                    <div className="flex items-center">
                                        {t(el)} {tableDevsSortingEntries[index] && getArrow(tableDevsSortingEntries[index])}
                                    </div>
                                </th>
                            ))}
                        </tr>
                    </thead>

                    <tbody>

                        {currentEntries
                            .map((dev, index) => (
                                <tr key={index} className="h-20 border-gray-300 dark:border-gray-600">
                                    <td className="max-w-xs w-6 truncate">{indexOfFirstEntry + index + 1}</td>
                                    <td className="max-w-xs w-24 truncate"><AvatarBubble dev={dev} /></td>
                                    <td className="max-w-xs truncate font-semibold">{dev.name}</td>
                                    <td className="max-w-xs truncate">{dev.email}</td>
                                    <td className="w-[250px]"><TableCategories categoriesDev={dev.categories} /></td>
                                    <td className="w-[200px]"><TableServers serversDev={dev.servers} /></td>
                                    <td className="max-w-xs truncate min-w-16"><RoleBubble rank={dev.rank} /></td>
                                    <td className="max-w-28 truncate " title={dev.disabled ? dev.disabled_until !== -1 ? IsoFormatToCustom(dev.disabled_until) : t("Indefinite", { ns: "settings" }) : "-"}>{dev.disabled ? dev.disabled_until !== -1 ? IsoFormatToCustom(dev.disabled_until) : t("Indefinite", { ns: "settings" }) : "-"}</td>
                                    <td className="max-w-xs w-24 truncate">{activeTicketNumbers ? activeTicketNumbers[dev.id] : ''}</td>
                                    <td className="max-w-xs w-[200px]"><DevActions dev={dev} setSelectedDev={setSelectedDev} /></td>
                                </tr>
                            ))}

                    </tbody>
                </table>
                <div className={`flex w-full justify-center bg-white dark:bg-gray-700 p-5 rounded-b-lg ${data.length !== 0 && "hidden"}`}>
                    <p>{t('No entries found')}</p>
                </div>
            </div>
            <PaginationComponent data={data} sortedData={sortedData} entriesPerPage={entriesPerPage} setIndexOfFirstEntry={setIndexOfFirstEntry}
                setIndexOfLastEntry={setIndexOfLastEntry} />
        </>
    )
}


const DevActions = ({ dev, setSelectedDev }) => {
    const { t } = useTranslation('settings')
    const { user } = useContext(AccountContext)
    const { hasPermission } = useContext(PermissionContext)

    const handleDisableDev = () => {
        document.getElementById('disable-dev-modal').showModal()
        setSelectedDev(dev)
    }

    const handleEnableDev = () => {
        document.getElementById('enable-dev-modal').showModal()
        setSelectedDev(dev)
    }

    const handlePasswordChange = () => {
        document.getElementById('password-change-modal').showModal()
        setSelectedDev(dev)
    }

    const handleEditDev = () => {
        document.getElementById('edit-dev-modal').showModal()
        setSelectedDev(dev)
    }


    const handleEditDevPermissions = () => {
        document.getElementById('edit-dev-permissions-modal').showModal()
        setSelectedDev(dev)
    }


    const handleDeleteDev = () => {
        document.getElementById('delete-dev-modal').showModal()
        setSelectedDev(dev)
    }

    const handleDisperseUserTickets = () => {
        document.getElementById('disperse-dev-tickets-modal').showModal()
        setSelectedDev(dev)
    }

    return (
        <>
            <div className="flex gap-2 flex-wrap">

                {
                    hasPermission("users:disable") &&
                    (
                        dev.disabled ?
                            <button title={t("Enable")} className="btn btn-sm border-gray-300 dark:border-gray-600 hover:border-gray-300 dark:hover:border-gray-500 w-9 h-9 p-0 text-white bg-emerald-500 hover:bg-emerald-600"
                                onClick={handleEnableDev}
                            ><TbUser size={18} /></button>
                            :
                            <button title={t("Disable")} className="btn btn-sm border-gray-300 dark:border-gray-600 hover:border-gray-300 dark:hover:border-gray-500 w-9 h-9 p-0 text-white bg-rose-500 hover:bg-rose-600"

                                onClick={handleDisableDev}
                            ><TbUserOff size={18} /></button>
                    )
                }
                {
                    hasPermission("users:disperse_tickets") &&
                    <button title={t("Disperse user's tickets")} className="btn btn-sm border-gray-300 dark:border-gray-600 hover:border-gray-300 dark:hover:border-gray-500 w-9 h-9 p-0 text-white bg-emerald-600 hover:bg-emerald-700"
                        onClick={handleDisperseUserTickets}>
                        <IoTicketOutline size={18} /></button>
                }
                {
                    hasPermission("users:set_categories") &&
                    <button title={t("Edit")} className="btn btn-sm border-gray-300 dark:border-gray-600 hover:border-gray-300 dark:hover:border-gray-500 w-9 h-9 p-0 text-white bg-cyan-500 hover:bg-cyan-600"
                        onClick={handleEditDev}
                    ><CiEdit size={18} /></button>
                }
                {
                    hasPermission("users:set_permissions") &&
                    <button title={t("Edit permissions")} className="btn btn-sm border-gray-300 dark:border-gray-600 hover:border-gray-300 dark:hover:border-gray-500 w-9 h-9 p-0 text-white bg-violet-500 hover:bg-violet-600"
                        onClick={handleEditDevPermissions}
                    ><TbUserCog size={18} /></button>
                }
                {
                    hasPermission("users:reset_pw") &&
                    <button title={t("Reset password")} disabled={dev.id == user.id} className="btn btn-sm border-gray-300 dark:border-gray-600 hover:border-gray-300 dark:hover:border-gray-500 w-9 h-9 p-0 text-white bg-amber-500 hover:bg-amber-600"
                        onClick={handlePasswordChange}>
                        <IoKey size={18} /></button>
                }
                {
                    hasPermission("users:delete") &&
                    <button title={t("Delete")} className="btn btn-sm border-gray-300 dark:border-gray-600 hover:border-gray-300 dark:hover:border-gray-500 w-9 h-9 p-0 text-white bg-red-500 hover:bg-red-600"
                        onClick={handleDeleteDev}
                    ><MdOutlineDeleteOutline size={18} /></button>
                }

            </div>
        </>
    )
}


const RoleBubble = ({ rank }) => {

    return (
        <div className={`${devRankStyles[rank]} p-[6px] rounded-lg w-16 text-center`}>
            <span >{capitalizeFirstLetter(rank)}</span>
        </div>
    )
}



export const AvatarBubble = ({ dev }) => {

    const hasImage = dev.avatar.length > 3

    return (
        <div className="chat-image avatar">

            <div className="w-10 rounded-full">

                {!hasImage ?
                    <div className="w-10 h-10 rounded-full bg-fuchsia-700 flex items-center justify-center text-white text-lg select-none">
                        {dev.class === "dev" ? "GM" : dev.name[0].toUpperCase()}
                    </div>
                    :
                    <img
                        alt="Tailwind CSS chat bubble component"
                        src={setImageUrl(dev.avatar)} />

                }
            </div>
        </div>
    )
}


const TableCategories = ({ categoriesDev }) => {
    const { language } = useContext(AccountContext) 
    const { categories, deletedCategories } = useContext(ContentContext)
    const rows = [];
    let categoryValues = {}
    categoriesDev.forEach(element => {
        categoryValues[element] = categories[element] ? categories[element].value : 100
    });
    const sortedcategoriesDev = categoriesDev.slice().sort((a, b) => a.value - b.value);
    for (let i = 0; i < categoriesDev.length; i += 4) {
        rows.push(categoriesDev.sort((a, b) => categoryValues[a] - categoryValues[b]).slice(i, i + 4));
    }

    const getCategoryConfig = (category) => {
        return {
            status: categories[category] ? (categories[category]?.locales?.[language] ? categories[category]?.locales[language] : categories[category]?.title) : deletedCategories[category] ? deletedCategories[category].title : "UNK",
            style: categories[category] ? categories[category].style : deletedCategories[category] ? deletedCategories[category].style : "bg-primary text-white",
            icon: ticketCategoryConfigs[category] ? ticketCategoryConfigs[category].icon : <BiCategory />
        }
    }

    return (
        <div className="flex flex-col gap-1">
            {rows.map((row, rowIndex) => (
                <div key={rowIndex} className="flex">
                    {row.map((category, index) => (
                        <ExpandableBubbleSidebar key={index} config={getCategoryConfig(category)} />

                    ))}
                </div>
            ))}

        </div>
    )
}


const TableServers = ({ serversDev }) => {
    const { servers, deletedServers } = useContext(ContentContext)
    const rows = [];
    let serverValues = {}
    serversDev?.forEach(element => {
        serverValues[element] = servers[element] ? servers[element].value : 100
    });

    for (let i = 0; i < serversDev?.length; i += 4) {
        rows.push(serversDev.sort((a, b) => serverValues[a] - serverValues[b]).slice(i, i + 4));
    }

    const getServerConfig = (server) => {
        return {
            status: servers[server]?.title ?? deletedServers[server]?.title ?? "UNK",
            style: servers[server]?.style ?? deletedServers[server]?.style ?? "bg-primary text-white",
            icon: <AvatarPlaceholder value={servers[server]?.title[0] ?? deletedServers[server]?.title[0] ?? "s"} style={servers[server]?.style ?? deletedServers[server]?.style ?? "bg-primary text-white"} />
        }
    }

    return (
        <div className="flex flex-col gap-1">
            {rows.map((row, rowIndex) => (
                <div key={rowIndex} className="flex">
                    {row.map((server, index) => (
                        <ExpandableBubbleSidebar key={index} config={getServerConfig(server)} />

                    ))}
                </div>
            ))}
        </div>
    )
}

const AvatarPlaceholder = ({ value, style }) => {

    return (
        <div className="avatar placeholder">
            <div className={`${style} w-4 rounded-full`}>
                <span className="text-md">{value}</span>
            </div>
        </div>
    )
}


export const DevEditModal = ({ selectedDev, setSelectedDev }) => {
    const { t } = useTranslation(['settings', 'common'])
    const { setDevs, language } = useContext(AccountContext)
    const { categories, servers, openErrorModal } = useContext(ContentContext)
    const [includedCategories, setIncludedCategories] = useState([])
    const [includedServers, setIncludedServers] = useState([])
    const [submitCondition, setSubmitCondition] = useState(false)

    const onClose = () => {
        setSelectedDev(null)
        document.getElementById('edit-dev-modal').close()

    }

    useEffect(() => {
        if (selectedDev) {
            setIncludedCategories(selectedDev.categories)
            setIncludedServers(selectedDev.servers ?? [])
        }
    }, [selectedDev])

    useEffect(() => {
        if (selectedDev) {
            setSubmitCondition(eqSet(new Set(selectedDev.categories), new Set(includedCategories)) && eqSet(new Set(selectedDev.servers), new Set(includedServers)))
        }
    }, [includedCategories, includedServers])

    const onSubmit = () => {
        if (!submitCondition) {
            requestChangeDevResponsibilities({ userId: selectedDev.id, categories: includedCategories, servers: includedServers }).then((data) => {
                setDevs((prev) => { return { ...prev, [data.user.id]: data.user } })
                onClose()
            })
                .catch((error) => {
                    console.error(error.status, error.message)
                    openErrorModal(error)
                })
        }
    }

    const handleAddCategory = (category) => {
        setIncludedCategories((prevCategories) => [...prevCategories, category])
    }

    const handleRemoveCategory = (category) => {
        setIncludedCategories((prevCategories) => [...prevCategories.filter((cat) => cat !== category)])

    }

    const handleAddServer = (server) => {
        setIncludedServers((prevServers) => [...prevServers, server])
    }

    const handleRemoveServer = (server) => {
        setIncludedServers((prevServers) => [...prevServers.filter((serv) => serv !== server)])
    }

    return (
        <dialog id="edit-dev-modal" className="modal">
            <div className="modal-box flex flex-col gap-3 py-8 items-center max-w-max h-full bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-300">
                {
                    selectedDev &&
                    <>
                        <span>{t('Edit')} <span className="font-semibold">{selectedDev.name}</span></span>
                        <span>{t('Change user categories:')}</span>
                        <div className="grid grid-cols-2 gap-3 py-3 px-2 border rounded-lg select-none w-full">
                            <div className="flex flex-col gap-1">
                                <div className="flex flex-col bg-violet-100 text-gray-800 max-w-max p-1 rounded-lg mb-2">
                                    <span className="font-semibold">{t('Added Categories')}</span>
                                    <span>{t('Click to remove')}</span>
                                </div>
                                {Object.keys(categories).length > 0 &&
                                    includedCategories.map((category, index) => (
                                        <div key={category.id ? category.id : index} className="cursor-pointer select-none ltr:hover:translate-x-1 rtl:hover:-translate-x-1 transition-all duration-200 max-w-max" onClick={() => { handleRemoveCategory(category) }}>
                                            <span className={`${categories[category].style} rounded-full px-[6px]`}>{categories[category]?.locales?.[language] ? categories[category]?.locales?.[language] : t(categories[category].title, { 'ns': 'common' })}</span>
                                        </div>
                                    ))}
                            </div>
                            <div className="flex flex-col gap-1">
                                <div className="flex flex-col bg-green-100 text-gray-800 max-w-max p-1 rounded-lg mb-2">
                                    <span className="font-semibold">{t('Other Categories')}</span>
                                    <span>{t('Click to add')}</span>
                                </div>
                                {Object.keys(categories).length > 0 &&
                                    Object.keys(categories).filter((category) => !includedCategories.includes(category)).map((category, index) => (
                                        <div key={category.id ? category.id : index} className=" cursor-pointer ltr:hover:translate-x-1 rtl:hover:-translate-x-1 transition-all duration-200 max-w-max" onClick={() => { handleAddCategory(category) }} >
                                            <span className={`${categories[category].style} rounded-full px-[6px] `}>{categories[category]?.locales?.[language] ? categories[category]?.locales?.[language] : t(categories[category].title, { 'ns': 'common' })}</span>
                                        </div>
                                    ))}
                            </div>
                        </div>
                        <span>{t('Change user servers:')}</span>
                        <div className="grid grid-cols-2 gap-3 py-3 px-2 border rounded-lg select-none w-full">
                            <div className="flex flex-col gap-1">
                                <div className="flex flex-col bg-violet-100 text-gray-800 max-w-max p-1 rounded-lg mb-2">
                                    <span className="font-semibold">{t('Added Servers')}</span>
                                    <span>{t('Click to remove')}</span>
                                </div>
                                {Object.keys(servers).length > 0 &&
                                    includedServers.map((server, index) => (
                                        <div key={server.id ?? index} className="cursor-pointer select-none ltr:hover:translate-x-1 rtl:hover:-translate-x-1 transition-all duration-200 max-w-max" onClick={() => { handleRemoveServer(server) }}>
                                            <span className={`${servers[server].style} rounded-full px-[6px]`}>{servers[server].title}</span>
                                        </div>
                                    ))}
                            </div>
                            <div className="flex flex-col gap-1">
                                <div className="flex flex-col bg-green-100 text-gray-800 max-w-max p-1 rounded-lg mb-2">
                                    <span className="font-semibold">{t('Other Servers')}</span>
                                    <span>{t('Click to add')}</span>
                                </div>
                                {Object.keys(servers).length > 0 &&
                                    Object.keys(servers).filter((server) => !includedServers.includes(server)).map((server, index) => (
                                        <div key={server.id ?? index} className=" cursor-pointer ltr:hover:translate-x-1 rtl:hover:-translate-x-1 transition-all duration-200 max-w-max" onClick={() => { handleAddServer(server) }} >
                                            <span className={`${servers[server].style} rounded-full px-[6px] `}>{servers[server].title}</span>
                                        </div>
                                    ))}
                            </div>
                        </div>
                        <div className="flex gap-3 mt-auto">

                            <button className="btn bg-primary hover:bg-sky-600 border-none text-white" disabled={submitCondition} onClick={onSubmit}>{t('Confirm')}</button>
                            <button className={`btn ${darkAndLightThemeDefault}`} onClick={onClose}>{t('Cancel')}</button>
                        </div>
                    </>
                }
            </div>
            <form method="dialog" className="modal-backdrop">
                <button onClick={onClose}>close</button>
            </form>
        </dialog>
    )
}


export const DevEditPermissionsModal = ({ selectedDev, setSelectedDev }) => {
    const { t } = useTranslation(['settings', 'common'])
    const { user, setDevs } = useContext(AccountContext)
    const { hasPermission } = useContext(PermissionContext)
    const { openErrorModal } = useContext(ContentContext)
    const [submitCondition, setSubmitCondition] = useState(false)

    const [rawPermissions, setRawPermissions] = useState([])
    const [originalPermissions, setOriginalPermissions] = useState({})
    const [userPermissions, setUserPermissions] = useState({})
    const [allPermissions, setAllPermissions] = useState({})
    const [rankPermissions, setRankPermissions] = useState([])
    const [newRank, setNewRank] = useState(null)

    const onClose = () => {
        setSelectedDev(null)
        document.getElementById('edit-dev-permissions-modal').close()
    }


    const hasUserPermission = (permission) => {
        return userPermissions[permission]
    }


    useEffect(() => {
        componentLoadingActive(true, "user-permissions-edit")
        requestAllPermissionsList({})
            .then((data) => {
                let permissions = {}
                for (let i = 0; i < data.permissions.length; i++) {
                    let permissionCategory = data.permissions[i].split(":")[0]
                    if (Object.keys(permissions).includes(permissionCategory)) {
                        permissions[permissionCategory].push(data.permissions[i])
                    }
                    else {
                        permissions[permissionCategory] = []
                        permissions[permissionCategory].push(data.permissions[i])
                    }
                }
                setRawPermissions(data.permissions)
                setAllPermissions(permissions)
            })
            .catch((error) => {
                console.error(error.status, error.message)
                openErrorModal(error)
            })
            .finally(() => {
                componentLoadingActive(false, "user-permissions-edit")
            })
    }, [])

    useEffect(() => {
        if (selectedDev && Object.keys(allPermissions).length > 0) {
            componentLoadingActive(true, "user-permissions-edit")
            requestUserPermissionList({ user_id: selectedDev.id })
                .then((data) => {
                    let permissions = {}
                    for (let i = 0; i < rawPermissions.length; i++) {
                        permissions[rawPermissions[i]] = data.permissions.includes(rawPermissions[i])
                    }
                    setOriginalPermissions(permissions)
                    setUserPermissions(permissions)
                })
                .catch((error) => {
                    console.error(error.status, error.message)
                    openErrorModal(error)
                })
                .finally(() => {
                    componentLoadingActive(false, "user-permissions-edit")
                })

            setNewRank(selectedDev.rank)
        }
    }, [selectedDev, allPermissions])


    const onSubmit = () => {
        if (submitCondition) {
            let addList = []
            let removeList = []
            for (let i = 0; i < rawPermissions.length; i++) {
                let permission = rawPermissions[i]
                if (userPermissions[permission] !== originalPermissions[permission]) {
                    if (userPermissions[permission]) {
                        addList.push(permission)
                    }
                    else {
                        removeList.push(permission)
                    }
                }
            }
            componentLoadingActive(true)
            requestChangeUserPermissions({ userId: selectedDev.id, rank: newRank, addList: addList, removeList: removeList })
                .then((data) => {
                    setDevs((prev) => { return { ...prev, [data.user.id]: data.user } })
                    onClose()
                })
                .catch((error) => {
                    console.error(error.status, error.message)
                    openErrorModal(error)
                })
                .finally(() => {
                    componentLoadingActive(false)
                })
        }
    }

    const checkPermissionsChange = () => {
        if (newRank !== selectedDev.rank) {
            setSubmitCondition(true)
            return
        }

        for (let i = 0; i < rawPermissions.length; i++) {
            if (userPermissions[rawPermissions[i]] !== originalPermissions[rawPermissions[i]]) {
                setSubmitCondition(true)
                return
            }
        }
        setSubmitCondition(false)
    }

    const setRankPermissionList = ({ newRank }) => {
        componentLoadingActive(true, "user-permissions-edit")
        requestRankPermissionList({ rank: newRank })
            .then((data) => {
                setRankPermissions(data.permissions)
                let prev = { ...userPermissions }
                for (let i = 0; i < rawPermissions.length; i++) {
                    prev[rawPermissions[i]] = data.permissions.includes(rawPermissions[i])

                }
                setUserPermissions(() => ({ ...prev }))
            })
            .catch((error) => {
                console.error(error.status, error.message)
                openErrorModal(error)
            })
            .finally(() => {
                componentLoadingActive(false, "user-permissions-edit")
            })
    }

    useEffect(() => {
        if (selectedDev && Object.keys(originalPermissions).length > 0) {
            checkPermissionsChange()
        }
    }, [userPermissions, newRank])

    useEffect(() => {
        if (newRank) {
            setRankPermissionList({ newRank: newRank })
        }
    }, [newRank])

    const handleAddPermission = (permission) => {
        if (!hasPermission(permission)) {
            return
        }
        setUserPermissions((prev) => ({ ...prev, [permission]: true }))
    }


    const handleRemovePermission = (permission) => {
        if (!hasPermission(permission)) {
            return
        }
        setUserPermissions((prev) => ({ ...prev, [permission]: false }))
    }

    return (
        <dialog id="edit-dev-permissions-modal" className="modal">
            <div className="modal-box flex flex-col gap-3 py-8 items-center max-w-full h-full bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-300">
                <ComponentLoadingScreen tag={"user-permissions-edit"} />
                {
                    selectedDev &&
                    <>
                        <span>{t('Edit permissions')} <span className="font-semibold">{selectedDev.name}</span></span>
                        <span>{t('Change user rank:')}</span>
                        <div className="flex gap-3">
                            <div className="flex flex-col">
                                <select className="select select-bordered select-sm h-10 bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-500 text-gray-800 dark:text-gray-300" value={newRank || "dev"} onChange={(e) => setNewRank(e.target.value)} >
                                    <option disabled={!hasPermission("users:set_admin")} value={"admin"} >Admin</option>
                                    <option value={"mod"}>Mod</option>
                                    <option value={"dev"}>Dev</option>

                                </select>
                                
                            </div>
                            <MdOutlineRestartAlt
                            onClick={() => setRankPermissionList({ newRank: newRank})}
                            className="self-center font-bold cursor-pointer hover:scale-125 duration-100 transition-all" size={25} title="Varsayılana Dön" />
                        </div>
                        <span className={`${selectedDev.rank !== newRank ? "text-red-600" : "invisible"}`}>{t("User's permissions will be changed and they will be forced to log out from the system.")}</span>

                        <span>{t('Set user permissions:')}</span>
                        <div className={`grid grid-cols-${Math.round(Object.keys(allPermissions).length / 2)} gap-3 py-3 px-2 border rounded-lg select-none w-full`}>
                            {
                                Object.keys(allPermissions).map((permissionCategory, index) =>
                                    <div key={index} className="flex flex-col gap-2">
                                        <div className="flex gap-4 items-center">
                                            <span className="font-semibold">{permissionCategory}</span>
                                            <div className="flex items-center relative w-full">

                                                <div className="flex items-center justify-center w-5 h-5 rounded-full border border-gray-300 dark:border-gray-500 peer opacity-50 hover:opacity-100">
                                                    <MdQuestionMark size={12} />
                                                </div>
                                                <div className="absolute bg-gray-100 dark:bg-gray-700 w-full max-w-[300px] hidden peer-hover:flex top-full right-1/4 p-1 border">
                                                    <span className="text-sm">{t(`permissionExplanations.${permissionCategory}` ?? "")}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="flex flex-col gap-1">
                                            {
                                                allPermissions[permissionCategory].map((permission, index) =>
                                                    <div key={permission} className={`flex gap-1 items-center max-w-max ${hasPermission(permission) ? "cursor-pointer" : "text-gray-400"}`}
                                                        onClick={() => hasUserPermission(permission) ? handleRemovePermission(permission) : handleAddPermission(permission)}>
                                                        {
                                                            hasUserPermission(permission) ?
                                                                <span className="text-green-500">
                                                                    <MdDone />
                                                                </span>
                                                                :
                                                                <span className="text-red-600">
                                                                    <MdClose />
                                                                </span>
                                                        }
                                                        <span className={`${originalPermissions[permission] !== hasUserPermission(permission) ? "text-blue-400" : ""}`}>{permission}</span>
                                                    </div>
                                                )
                                            }

                                        </div>
                                    </div>
                                )
                            }
                        </div>
                        <div className="flex gap-3 mt-auto">

                            <button className="btn bg-primary hover:bg-sky-600 border-none text-white" disabled={!submitCondition} onClick={onSubmit}>{t('Confirm')}</button>
                            <button className={`btn ${darkAndLightThemeDefault}`} onClick={onClose}>{t('Cancel')}</button>
                        </div>
                    </>
                }
            </div>
            <form method="dialog" className="modal-backdrop">
                <button onClick={onClose}>close</button>
            </form>
        </dialog>
    )
}


export const DevDisableModal = ({ selectedDev, setSelectedDev }) => {
    const { t } = useTranslation('settings')
    const { setDevs } = useContext(AccountContext)
    const { openErrorModal } = useContext(ContentContext)

    const [isIndefinite, setIsIndefinite] = useState(false)

    const [dateNowUtc, setDateNowUtc] = useState(null)
    const [untilDay, setUntilDay] = useState(1)
    const [untilMonth, setUntilMonth] = useState(0)
    const [untilYear, setUntilYear] = useState(2025)

    const [dayOptions, setDayOptions] = useState([])
    const [monthOptions, setMonthOptions] = useState([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11])
    const [yearOptions, setYearOptions] = useState([])

    const endOfDayHour = 19

    const onClose = () => {
        setSelectedDev(null)
        document.getElementById('disable-dev-modal').close()

    }

    const onSubmit = () => {
        requestDisableUserUntil({ id: selectedDev.id, date: isIndefinite ? "indefinite" : `${String(untilDay).padStart(2, '0')}.${String(untilMonth + 1).padStart(2, '0')}.${String(untilYear)}` })
            .then((data) => {
                setDevs((prev) => { return { ...prev, [data.user.id]: data.user } })
                onClose()
            })
            .catch((error) => {
                console.error(error.status, error.message)
                openErrorModal(error)
            })
    }

    function getAllDatesInYear(year) {
        const dates = [];
        const startDate = new Date(Date.UTC(year, 0, 1)); // Jan 1st of the given year
        const endDate = new Date(Date.UTC(year + 1, 0, 1)); // Jan 1st of the next year

        for (let date = startDate; date < endDate; date.setUTCDate(date.getUTCDate() + 1)) {
            const yyyy = date.getUTCFullYear();
            const mm = String(date.getUTCMonth() + 1).padStart(2, '0'); // Months are 0-based
            const dd = String(date.getUTCDate()).padStart(2, '0');
            dates.push(`${yyyy}-${mm}-${dd}`);
        }

        return dates;
    }

    useEffect(() => {

        const now = new Date(Date.now()); // Get current timestamp
        let addDay = 0
        if (now.getUTCHours() + 3 >= endOfDayHour) {
            addDay = 1
        }
        const utc3 = new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate() + addDay, now.getUTCHours() + 3); // Adjust for UTC+3

        const day = utc3.getDate();
        const month = utc3.getMonth(); // Months are zero-based
        const year = utc3.getFullYear();
        const hour = utc3.getHours();

        setDateNowUtc({ hour: hour, day: day, month: month, year: year })
        setYearOptions([year, year + 1, year + 2, year + 3, year + 4])
        setUntilDay(day)
        setUntilMonth(month)
        setUntilYear(year)
    }, [selectedDev])


    useEffect(() => {
        let dates = getAllDatesInYear(untilYear)
        let daysOfMonth = dates.filter((date) => date.includes(`-${String(untilMonth + 1).padStart(2, "0")}-`)).map((date) => parseInt(date.split("-")[2]))
        if (dateNowUtc && untilYear === dateNowUtc.year && untilMonth === dateNowUtc.month) {
            let eligibleDays = daysOfMonth.slice(dateNowUtc.day - 1)
            daysOfMonth = eligibleDays

        }
        setDayOptions(daysOfMonth)
        if (!daysOfMonth.includes(untilDay)) {
            setUntilDay(daysOfMonth[0])
        }

    }, [dateNowUtc, untilMonth, untilYear])

    useEffect(() => {
        if (dateNowUtc && untilYear === dateNowUtc.year) {
            let eligibleMonths = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].slice(dateNowUtc.month)
            setMonthOptions([...eligibleMonths])
            if (!eligibleMonths.includes(untilMonth)) {
                setUntilMonth(eligibleMonths[0])
            }
        }
        else {
            setMonthOptions([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11])
        }
    }, [dateNowUtc, untilYear])

    const handleChangeDay = (e) => {
        setUntilDay(parseInt(e.target.value))
    }

    const handleChangeMonth = (e) => {
        setUntilMonth(parseInt(e.target.value))
    }

    const handleChangeYear = (e) => {
        setUntilYear(parseInt(e.target.value))
    }

    return (
        <dialog id="disable-dev-modal" className="modal">
            {
                selectedDev &&
                <>
                    <div className="modal-box lg:w-full max-w-[812px] flex flex-col gap-5 py-8 items-center  bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-300">
                        <span>{t('Disable')} <span className="font-semibold">{selectedDev.name}</span></span>

                        <span>{t("Determine the user inactivity time.")}</span>

                        <div className="grid grid-cols-7 items-center justify-center gap-3">
                            <span className={`${isIndefinite ? "font-semibold opacity-100" : "opacity-50"} col-span-3 justify-self-end transition-all duration-200`}>{t("Indefinite")}</span>
                            <input type="checkbox" className="justify-self-center toggle toggle-md toggle-primary bg-red-600 text-red-600 " checked={!isIndefinite} onChange={(e) => setIsIndefinite(!e.target.checked)} />
                            <div className={`col-span-3 justify-self-start flex items-center gap-2 ${isIndefinite ? "opacity-50" : "opacity-100"} transition-all duration-200`}>

                                <select className="select select-sm" disabled={isIndefinite} value={untilDay || 1} onChange={handleChangeDay}>
                                    {
                                        dayOptions.map((day, index) =>
                                            <option key={index} value={day}>{String(day).padStart(2, "0")}</option>
                                        )
                                    }
                                </select>
                                <select className="select select-sm" disabled={isIndefinite} value={untilMonth || 0} onChange={handleChangeMonth}>
                                    {
                                        monthOptions.map((month, index) =>
                                            <option key={index} value={month}>{String(month + 1).padStart(2, "0")}</option>
                                        )
                                    }
                                </select>
                                <select className="select select-sm" disabled={isIndefinite} value={untilYear || 2025} onChange={handleChangeYear}>
                                    {
                                        yearOptions.map((year, index) =>
                                            <option key={index} value={year}>{year}</option>
                                        )
                                    }
                                </select>

                            </div>
                        </div>

                        <span className="text-md">{t('The user will not be assigned any new tickets while disabled.')}</span>
                        {
                            !isIndefinite &&
                            <div className="flex flex-col gap-1 items-center">
                                <span>{t("Disable until")}</span>
                                <span className="text-lg font-semibold">{`19:00 ${String(untilDay).padStart(2, "0")}.${String(untilMonth + 1).padStart(2, "0")}.${untilYear} (UTC +3)`}</span>
                            </div>
                        }
                        <span className="text-md">{t('Do you want to continue?')}</span>
                        <div className="flex gap-3 mt-5">

                            <button className="btn bg-primary hover:bg-sky-600 border-none text-white" onClick={onSubmit}>{t('Confirm')}</button>
                            <button className={`btn ${darkAndLightThemeDefault}`} onClick={onClose}>{t('Cancel')}</button>
                        </div>
                    </div>
                </>
            }
            <form method="dialog" className="modal-backdrop">
                <button onClick={onClose}>close</button>
            </form>
        </dialog>
    )
}


export const DevEnableModal = ({ selectedDev, setSelectedDev }) => {
    const { t } = useTranslation('settings')
    const { setDevs } = useContext(AccountContext)
    const { openErrorModal } = useContext(ContentContext)

    const onClose = () => {
        setSelectedDev(null)
        document.getElementById('enable-dev-modal').close()

    }

    const onSubmit = () => {
        requestEnableUser({ id: selectedDev.id })
            .then((data) => {
                setDevs((prev) => { return { ...prev, [data.user.id]: data.user } })
                onClose()
            })
            .catch((error) => {
                console.error(error.status, error.message)
                openErrorModal(error)
            })

    }

    return (
        <dialog id="enable-dev-modal" className="modal">
            <div className="modal-box flex flex-col gap-3 py-8 items-center max-w-max bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-300">
                {
                    selectedDev &&
                    <>
                        <span>{t('Enable')} <span className="font-semibold">{selectedDev.name}</span></span>
                        <span className="text-md">{t('The user will be able to get tickets assigned again.')}</span>
                        <span className="text-md">{t('Do you want to continue?')}</span>
                        <div className="flex gap-3 mt-5">

                            <button className="btn bg-primary hover:bg-sky-600 border-none text-white" onClick={onSubmit}>{t('Confirm')}</button>
                            <button className={`btn ${darkAndLightThemeDefault}`} onClick={onClose}>{t("Cancel")}</button>
                        </div>
                    </>
                }
            </div>
            <form method="dialog" className="modal-backdrop">
                <button onClick={onClose}>close</button>
            </form>
        </dialog>
    )
}


export const DevDisperseTicketsModal = ({ selectedDev, setSelectedDev }) => {
    const { t } = useTranslation('settings')
    const { setDevs } = useContext(AccountContext)
    const { openErrorModal } = useContext(ContentContext)

    const onClose = () => {
        setSelectedDev(null)
        document.getElementById('disperse-dev-tickets-modal').close()

    }

    const onSubmit = () => {
        requestDisperseUserTickets({ id: selectedDev.id })
            .then((data) => {
                setDevs((prev) => { return { ...prev, [data.user.id]: data.user } })
                onClose()
            })
            .catch((error) => {
                console.error(error.status, error.message)
                openErrorModal(error)
            })

    }

    return (
        <dialog id="disperse-dev-tickets-modal" className="modal">
            <div className="modal-box flex flex-col gap-3 py-8 items-center max-w-max bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-300">
                {
                    selectedDev &&
                    <>
                        <span>{t("Disperse user's tickets")} <span className="font-semibold">{selectedDev.name}</span></span>
                        <span className="text-md">{t('disperse_tickets_message_modal')}</span>
                        <span className="text-md">{t('Do you want to continue?')}</span>
                        <div className="flex gap-3 mt-5">

                            <button className="btn bg-primary hover:bg-sky-600 border-none text-white" onClick={onSubmit}>{t('Confirm')}</button>
                            <button className={`btn ${darkAndLightThemeDefault}`} onClick={onClose}>{t('Cancel')}</button>
                        </div>
                    </>
                }
            </div>
            <form method="dialog" className="modal-backdrop">
                <button onClick={onClose}>close</button>
            </form>
        </dialog>
    )
}


export const PasswordChangeModal = ({ selectedDev, setSelectedDev }) => {
    const { t } = useTranslation('settings')
    const { openErrorModal } = useContext(ContentContext)
    const [password, setPassword] = useState("")
    const [rePassWord, setRePassword] = useState("")
    const [dontMatch, setDontMatch] = useState(false)
    const [success, setSuccess] = useState(false)

    useEffect(() => {
        if (password !== rePassWord && rePassWord.length > 0) {
            setDontMatch(true)
        }
        else {
            setDontMatch(false)
        }
    }, [password, rePassWord])

    const onClose = () => {
        setSelectedDev(null)
        setPassword("")
        setRePassword("")
        setSuccess(false)
        document.getElementById('password-change-modal').close()
    }

    const onSubmit = () => {
        requestChangePassword({ devId: selectedDev.id, password: password, rePassword: rePassWord })
            .then((data) => {
                setSuccess(true)
            })
            .catch((error) => {
                console.error(error.status, error.message)
                openErrorModal(error)

            })
    }

    const submitCondition = validatePassword(password) && validatePassword(rePassWord) && (password == rePassWord) && !success

    return (
        <dialog id="password-change-modal" className="modal">
            <div className="modal-box flex max-w-max gap-3 py-8 items-center relative bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-300">
                {
                    selectedDev && !success &&
                    <>
                        <div className="flex flex-col gap-3 items-center">
                            <span>{t('Change password')} <span className="font-semibold">{selectedDev.name}</span></span>
                            <div className="flex gap-3">

                                <div className="flex flex-col gap-3 items-center">


                                    <div className="flex flex-col">

                                        <label className="label">
                                            <span className="label-text text-sm text-gray-800 dark:text-gray-300 font-semibold">{t('Password')}</span>
                                        </label>
                                        <input type="password"
                                            placeholder={t("Password")}
                                            value={password}
                                            pattern={passwordPattern}
                                            onChange={(e) => setPassword(e.target.value)}
                                            className="input input-bordered peer/p1 text-gray-800 dark:text-gray-300 bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-600 w-60" />
                                        <p className="max-w-max invisible peer-invalid/p1:visible text-pink-600 text-sm mt-1 ml-1">
                                            {t('Please enter a valid password.')}
                                            {/* Password should include at least 1 special character, upper case letter, lower case letter and a number (0-9). Must have more than 8 characters. */}
                                        </p>
                                    </div>

                                    <div className="flex flex-col ">

                                        <label className="label">
                                            <span className="label-text text-sm text-gray-800 dark:text-gray-300 font-semibold">{t('Confirm Password')}</span>
                                        </label>
                                        <input type="password"
                                            placeholder={t("Password")}
                                            value={rePassWord}
                                            pattern={passwordPattern}
                                            onChange={(e) => setRePassword(e.target.value)}
                                            className="input input-bordered  text-gray-800 dark:text-gray-300 bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-600 w-60" />
                                        <p className={`max-w-max ${password.length > 0 && dontMatch && rePassWord.length > 0 ? "visible" : "invisible"}  text-pink-600 text-sm mt-1 ml-1`}>
                                            {t('Passwords do not match.')}
                                        </p>
                                    </div>

                                    <div className="flex gap-3 mt-5">

                                        <button className="btn bg-primary hover:bg-sky-600 border-none text-white" disabled={!submitCondition} onClick={onSubmit}>{t('Submit')}</button>
                                        <button className={`btn ${darkAndLightThemeDefault}`} onClick={onClose}>{t('Cancel')}</button>
                                    </div>
                                </div>
                                <div className="flex flex-col justify-center">
                                    <PasswordRulesModule password={password} />
                                </div>
                            </div>
                        </div>

                    </>
                }
                {
                    selectedDev && success &&
                    <div className="flex flex-col items-center py-3">

                        <span className="text-green-700">{t('Password was changed for user')} <span className="font-semibold">{selectedDev.name}</span></span>

                        <div className="flex gap-3 mt-5">

                            <button className={`btn ${darkAndLightThemeDefault}`} onClick={onClose}>{t('Back')}</button>
                        </div>
                    </div>

                }

                <div className="absolute">

                    <div className="relative bottom-0">
                    </div>
                </div>
            </div>
            <form method="dialog" className="modal-backdrop">
                <button onClick={onClose}>close</button>
            </form>
        </dialog>

    )
}


export const DevDeleteModal = ({ selectedDev, setSelectedDev }) => {
    const { t } = useTranslation('settings')
    const { user, setDevs, openErrorModal } = useContext(AccountContext)
    const [errorMessage, setErrorMessage] = useState("")

    const onClose = () => {
        setSelectedDev(null)
        setErrorMessage("")
        document.getElementById('delete-dev-modal').close()

    }

    const onSubmit = () => {
        if (user.id === selectedDev.id) {
            setErrorMessage("You cannot delete yourself.")
        }
        else {

            requestDeleteDev({ userId: selectedDev.id }).then((data) => {
                if (data.confirm) {

                    setDevs((prev) => {
                        delete prev[selectedDev.id]
                        return { ...prev }
                    })
                }
                onClose()
            })
                .catch((error) => {
                    openErrorModal(error)
                    console.error(error.status, error.message)
                })
        }

    }

    const submitCondition = user.id !== (selectedDev && selectedDev.id)

    return (
        <dialog id="delete-dev-modal" className="modal">
            <div className="modal-box flex flex-col gap-3 py-8 items-center max-w-max bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-300">
                {
                    selectedDev &&
                    <>
                        <span>{t('Delete')} <span className="font-semibold">{selectedDev.name}</span></span>
                        <span className="text-md">{t('The user will be deleted permanently.')}</span>
                        <span className="text-md">{t("The user's assigned tickets will be re-assigned automatically.")}</span>
                        <span className="text-md">{t('Do you want to continue?')}</span>
                        <div className="flex gap-3 mt-5">

                            <button className="btn bg-primary hover:bg-sky-600 border-none text-white" disabled={!submitCondition} onClick={onSubmit}>{t('Confirm')}</button>
                            <button className={`btn ${darkAndLightThemeDefault}`} onClick={onClose}>{t('Cancel')}</button>
                        </div>
                        {
                            !submitCondition &&
                            <span className="text-md text-red-600">{t('You cannot delete yourself.')}</span>
                        }
                    </>
                }
            </div>
            <form method="dialog" className="modal-backdrop">
                <button onClick={onClose}>close</button>
            </form>
        </dialog>
    )
}


export const CreateNewDevModal = ({ }) => {
    const { t } = useTranslation('settings')
    const { setDevs } = useContext(AccountContext)
    const [email, setEmail] = useState("")
    const [rank, setRank] = useState("")
    const [userClass, setUserClass] = useState("")
    const [emailExists, setEmailExists] = useState(false)
    const [userToken, setUserToken] = useState("")
    const [errorMessage, setErrorMessage] = useState("")

    const navigator = useNavigate()

    const onClose = () => {
        document.getElementById('create-new-dev-modal').close()
        setEmail("")
        setRank("")
        setUserClass("")
        setEmailExists(false)
        setUserToken("")
    }

    useEffect(() => {
        if (userClass === "user") {
            setRank("user")
        }
    }, [userClass])

    const onSubmit = () => {
        if (submitCondition) {
            // requestCreateNewUser({email: email, userClass: userClass, userRank: rank}).then((data) => {
            //   setDevs(prev => ({...prev, [data.id]: data}))
            //   onClose()
            // })
            requestCreateNewUser({ email: email, userClass: userClass, userRank: rank, verbose: true }).then((data) => {
                setDevs(prev => ({ ...prev, [data.user.id]: data.user }))
                setUserToken(data.password_token)
            }).catch((error) => {
                console.error("Error creating new user:", error)
                setErrorMessage(error.message)
            })



        }
    }

    useEffect(() => {
        if (emailExists) {
            setEmailExists(false)
        }
    }, [email])

    const onBlur = () => {
        requestCheckEmailExists({ email: email }).then((data) => {
            setEmailExists(data.exists)
        })
    }

    const submitCondition = email !== "" && userClass !== "" && (userClass === "dev" ? rank !== "" : true) && !emailExists

    return (
        <dialog id="create-new-dev-modal" className="modal">
            <div className="modal-box flex flex-col gap-3 py-8 px-10 min-w-[480px] bg-gray-100 dark:bg-gray-700 items-center max-w-max">

                <span>{t('Create new user')}</span>
                <div className="flex flex-col items-start gap-3">

                    <div className="flex flex-col items-start">

                        <label className="label">
                            <span className="label-text text-sm text-gray-800 dark:text-gray-300 ">{t("Write user's e-mail.")}</span>
                        </label>
                        <input
                            placeholder={t("User e-mail")}
                            type="email"
                            value={email}
                            onBlur={onBlur}
                            onChange={(e) => setEmail(e.target.value)}
                            className="input input-bordered text-gray-800 dark:text-gray-300 bg-white dark:bg-gray-700  w-60 h-8 invalid:border-red-600"
                        />
                        {
                            emailExists &&
                            <span className="text-sm text-red-600">{t('This e-mail is already registered.')}</span>
                        }
                    </div>

                    <div className="flex gap-3">

                        <div className="flex flex-col items-start">

                            <label className="label">
                                <span className="label-text text-sm text-gray-800 dark:text-gray-300">{t("Select user's type.")}</span>
                            </label>

                            <select required className="select select-bordered select-sm max-w-max text-gray-800 dark:text-gray-300 bg-gray-100 dark:bg-gray-700"
                                value={userClass || ""} onChange={(e) => setUserClass(e.target.value)}
                            >
                                <option disabled value="">{t('Select type')}</option>
                                {
                                    Object.keys(userClasses).map((c, index) =>
                                        <option key={index} value={c}>{c === "user" ? t("User") : t("Employee")}</option>
                                    )
                                }
                            </select>

                        </div>
                        {
                            userClass == "dev" &&
                            <div className="flex flex-col items-start">

                                <label className="label">
                                    <span className="label-text text-sm text-gray-800 dark:text-gray-300">{t("Select user's rank.")}</span>
                                </label>

                                <select required className="select select-bordered select-sm max-w-max text-gray-800 dark:text-gray-300 bg-gray-100 dark:bg-gray-700"
                                    value={rank || ""} onChange={(e) => setRank(e.target.value)}
                                >
                                    <option disabled value="" className="disabled:text-gray-400 text-gray-400">{t('Select class')}</option>
                                    {
                                        Object.keys(devRankStyles).map((c, index) =>
                                            <option key={index} value={c}>{capitalizeFirstLetter(c)}</option>
                                        )
                                    }
                                </select>
                            </div>
                        }

                    </div>
                </div>
                {
                    userToken !== "" &&
                    <>
                        <span className="max-w-">{`${window.location.origin}/setup-password/${userToken}`}</span>
                        <a className="cursor-pointer underline" href={`${window.location.origin}/setup-password/${userToken}`}>Set password screen</a>
                    </>
                }
                {
                    errorMessage !== "" &&
                    <span className="text-red-600 font-semibold">{errorMessage}</span>
                }

                {
                    userToken !== "" &&
                    <div className="flex gap-3 mt-5">
                        <button className={`btn ${darkAndLightThemeDefault}`} onClick={onClose}>{t('Close')}</button>
                    </div>

                }
                {
                    userToken === "" &&
                    <div className="flex gap-3 mt-5">
                        <button className="btn bg-primary hover:bg-sky-600 border-none text-white" disabled={!submitCondition} onClick={onSubmit}>{t('Confirm')}</button>
                        <button className={`btn ${darkAndLightThemeDefault}`} onClick={onClose}>{t('Cancel')}</button>
                    </div>
                }


            </div>
            <form method="dialog" className="modal-backdrop">
                <button onClick={onClose}>close</button>
            </form>
        </dialog>
    )
}



export default DataTable;